var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-chart-3"},[_c('div',{staticClass:"lc3-header"},[_vm._v("收件省份占比")]),_c('div',{staticClass:"lc3-details"},[_vm._v("收件总数"),_c('span',[_vm._v(_vm._s(_vm.provinceTotal))])]),_c('div',{attrs:{"id":"province"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }